import {RouterProps} from "../../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {
    AssetSolarUsageValueObject
} from "../../../../data/value-object/asset/AssetSolarUsageValueObject";
import {useEffect} from "react";
import {AssetSolarUsageIO} from "../../../../io/AssetIO";
import {Body1, Spinner} from "@fluentui/react-components";
import {
    AssetSolarUsageDescription
} from "../../../../data/description/asset/AssetSolarUsageDescription";
import {AssetSolarUsageDomain} from "../../../../data/domain/asset/AssetSolarUsageDomain";
import {AssetSolarUsageDescriptor} from "../../../../data/descriptor/asset/AssetSolarUsageDescriptor";
import {DetailDefaultPanel, DetailDefaultTab} from "../../../DetailViews";

export default function Detail(props: RouterProps) {
    const params = useParams<{ assetSolarUsageId: string }>()
    const item = useStatePair<AssetSolarUsageValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.assetSolarUsageId !== undefined) {
            AssetSolarUsageIO
                .getById(BigInt(params.assetSolarUsageId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: AssetSolarUsageValueObject
}

function Page(props: PageProps) {
    return <>
        <div className={props.styles.row16}>
            <DetailDefaultTab {...props} />
            <DetailDefaultPanel
                {...props}
                client={AssetSolarUsageIO}
                description={AssetSolarUsageDescription}
                properties={props => <PropertyBody {...props} />}
                hideEdit
                hideDelete />
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof AssetSolarUsageDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "type":
        case "amount":
        case "lastAccumulation":
        case "positiveAccumulation":
        case "negativeAccumulation":
        case "createdAt":
            return <Body1>{AssetSolarUsageDescriptor[props.itemKey](props.item)}</Body1>
        case "userId":
            return <a href={`/users/${props.item.userId}`}><Body1>{AssetSolarUsageDescriptor[props.itemKey](props.item)}</Body1></a>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{AssetSolarUsageDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}